import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SpcialistService } from 'src/app/basic-data/services/Spcialist.service';
import { Globals } from 'src/app/shared/services/globals';
import { SpcialistDto } from 'src/app/shared/models/DTO/spcialist-dto';

@Component({
  selector: 'app-specialist-dashboard',
  templateUrl: './specialist-dashboard.component.html',
  styleUrls: ['./specialist-dashboard.component.css']
})
export class SpecialistDashboardComponent implements OnInit {

  constructor(private router: Router,
    public global: Globals, private toastr: ToastrService, private spcialistService: SpcialistService, private activeRoute: ActivatedRoute) { }

    specialist : SpcialistDto = new SpcialistDto();
  ngOnInit() {
    this.updateData()
  }

  updateData() {
    this.global.spinner = true;
    this.spcialistService.getSpecialistByUserId(this.global.UserId).subscribe(
      res => {
        this.specialist = (res as any).data
        console.log('sp', this.specialist)
        this.global.spinner = false;
      },
      err => {
        this.global.spinner = false;

        console.log(err, 'err')
      }
    )
  }

}
